import styled, { css } from 'styled-components';

import NextImage from 'next/image';

import Arrow from 'Elements/Button/Arrow';

export const Container = styled.section<{ $imageRight?: boolean }>`
    ${({ theme, $imageRight }) => css`
        position: relative;
        overflow: hidden;
        display: flex;
        width: 100%;
        background: ${theme.colors.tertiary.hex};
        flex-direction: column;

        @media ${theme.breakpoints.medium.media} {
            flex-direction: row;

            &:after {
                content: ' ';
                position: absolute;
                top: 0;
                right: 0;
                left: 0;
                bottom: 0;
                z-index: 1;
                height: 100%;
                width: 100%;
                background: ${$imageRight
                    ? `linear-gradient(
                            225deg,
                            rgba(255, 255, 255, 0) 40%,
                            rgba(${theme.colors.tertiary.rgb}, 1) 55%
                        ),
                        linear-gradient(
                            270deg,
                            rgba(255, 255, 255, 0) 40%,
                            rgba(${theme.colors.tertiary.rgb}, 1) 55%
                        ),
                        linear-gradient(
                            315deg,
                            rgba(255, 255, 255, 0) 40%,
                            rgba(${theme.colors.tertiary.rgb}, 1) 55%
                        )`
                    : `linear-gradient(
                        45deg,
                        rgba(255, 255, 255, 0) 40%,
                        rgba(${theme.colors.tertiary.rgb}, 1) 55%
                    ),
                    linear-gradient(
                        90deg,
                        rgba(255, 255, 255, 0) 40%,
                        rgba(${theme.colors.tertiary.rgb}, 1) 55%
                    ),
                    linear-gradient(
                        135deg,
                        rgba(255, 255, 255, 0) 40%,
                        rgba(${theme.colors.tertiary.rgb}, 1) 55%
                    )`};
            }
        }
    `}
`;

export const ImageWrapper = styled.div<{ $imageRight?: boolean }>`
    ${({ theme, $imageRight }) => css`
        position: relative;
        overflow: hidden;
        width: 100%;
        height: 10.5rem;

        @media ${theme.breakpoints.medium.media} {
            width: 50%;
            height: 100%;
            position: absolute;
        }

        ${$imageRight &&
        css`
            @media ${theme.breakpoints.medium.media} {
                right: 0;
            }
        `}
    `}
`;

export const StyledNextImage = styled(NextImage)<{ $imageRight?: boolean }>`
    ${({ theme, $imageRight }) => css`
        height: 100%;
        width: 100%;
        max-height: 10.5rem;
        object-fit: cover;

        @media ${theme.breakpoints.medium.media} {
            border-radius: 0 25% 25% 0;
            max-height: none;
        }

        ${$imageRight &&
        css`
            @media ${theme.breakpoints.medium.media} {
                border-radius: 25% 0 0 25%;
            }
        `}
    `}
`;

export const InnerWrapper = styled.div<{ $imageRight?: boolean }>`
    ${({ theme, $imageRight }) => css`
        display: flex;
        width: 100%;
        z-index: 2;
        position: relative;

        ${$imageRight &&
        css`
            @media ${theme.breakpoints.medium.media} {
                order: 1;
            }
        `}
    `}
`;

export const Inner = styled.div<{ $imageRight?: boolean }>`
    ${({ theme, $imageRight }) => css`
        color: ${theme.colors.secondary.hex};
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        text-align: center;
        align-items: center;
        padding: 1rem 0 1.5rem 0;

        @media ${theme.breakpoints.medium.media} {
            text-align: right;
            align-items: end;
            padding: 1.5rem 2.25rem 1.5rem 0.75rem;
        }

        @media ${theme.breakpoints.large.media} {
            padding: 6.875rem 0;
        }

        ${$imageRight &&
        css`
            @media ${theme.breakpoints.medium.media} {
                text-align: left;
                align-items: start;
                padding: 1.5rem 0.75rem 1.5rem 2.25rem;
            }

            @media ${theme.breakpoints.large.media} {
                padding: 6.875rem 0;
            }
        `}
    `}
`;

export const Heading = styled.h2`
    margin: 0 0 1.25rem;
    font-weight: 700;
`;

export const Description = styled.p`
    margin: 0 0 1.5rem;
    font-weight: 300;
`;

export const StyledArowButton = styled(Arrow)`
    ${({ theme }) => css`
        margin: 0;
        height: 2.5rem;

        @media ${theme.breakpoints.large.media} {
            height: 3.5rem;
        }
    `}
`;
